'use client';

import { JSX } from 'react';

import { GoogleLoginOneTouchButton } from '../../../components/google-login/GoogleLoginOneTouchButton';
import { useGoogleSignUpCallback } from './useGoogleSignUpCallback';

type Props = {
    planCode?: string;
    redirectAfterRegister?: string;
};

export function GoogleSignUpButton({ planCode, redirectAfterRegister }: Props): JSX.Element | null {
    const callback = useGoogleSignUpCallback(planCode, redirectAfterRegister);
    if (typeof window === 'undefined') {
        return null;
    }
    return (
        <div className="flex flex-row items-center justify-center w-full">
            <GoogleLoginOneTouchButton successCallback={callback} />
        </div>
    );
}
